module.exports = __WEBPACK_EXTERNAL_MODULE_34__;


/*****************
 ** WEBPACK FOOTER
 ** external "./node/extend"
 ** module id = 34
 ** module chunks = 0
 **/